import React, { useEffect, useState } from 'react';
import { Card } from "react-bootstrap";
import SingleAsset from "./SingleAsset";
import AssetDetails from "./AssetDetails";
import SiteAssetView from "./SiteAssetView";

function AssetsOverview({ 
  companyId, 
  sudoSiteId, 
  assets, 
  viewAssetDetails, 
  setViewAssetDetails, 
  selectedOption, 
  navName,
  setNavName, 
  setNavSiteViewName, 
  navSiteViewName,
  setAssetCount, 
  setSiteAssetView, 
  siteAssetView,
  setLoadingSiteViewData,
  timezone,
  localAssetId,
  setLocalAssetId,
  setAssetPhoto,
  setNavIcon,
  scrollToTop,
  scrollableRef,
  mctClusterId,
  mobileAppId,
  forceReload,
  setForceReload,
  editMode,
  setEditMode,
  setChangeDetected,
  changeDetected,
  editData,
  setEditData,
  initialFormData,
  setInitialFormData,
  setTooltipDescription,
  setInvalid,
  siteViewData,
  setSiteViewData,
  setShowEditButton,
}) {

  const [assetFields, setAssetFields] = useState([]);
  const [displayPageIndex, setDisplayPageIndex] = useState(0);
  const [assetDefaults, setAssetDefaults] = useState([]);

  useEffect(() => {
    if (assets.length > 0) {
      const countValues = assets.map(asset => asset?.asset_count)
      const total = countValues.reduce((sum, num) => sum + num, 0)
      setAssetCount(total);
    }
  }, [assets, setAssetCount, forceReload])

  useEffect(() => {
    // setViewAssetDetails(false)
    // setSiteAssetView(false)
    setNavSiteViewName("")
  }, [selectedOption, setViewAssetDetails, setNavSiteViewName, setSiteAssetView])

  return (
    <Card id="company-asset-page" ref={scrollableRef} >
      {!viewAssetDetails ?
        <div className="assets-grid-container">
          {assets
            .slice() // create a shallow copy to avoid mutating original array
            .sort((a, b) => b.asset_count - a.asset_count) // sorts by descending asset count value
            .map((asset, id) => (
              <div key={id} className="grid-item">
                <SingleAsset 
                  asset={asset}
                  localAssetId={localAssetId}
                  setLocalAssetId={setLocalAssetId}
                  setNavName={setNavName}
                  sudoSiteId={sudoSiteId} 
                  companyId={companyId} 
                  viewAssetDetails={viewAssetDetails} 
                  setViewAssetDetails={setViewAssetDetails} 
                  setAssetFields={setAssetFields}
                  assetIcon={asset?.icon ?? "fas fa-tag"}
                  setNavIcon={setNavIcon}
                />
              </div>
            ))
          }
        </div>
      : !siteAssetView ?
          <div className='asset-details-container'>
            <AssetDetails
              localAssetId={localAssetId}
              setLocalAssetId={setLocalAssetId}
              assetFields={assetFields} 
              sudoSiteId={sudoSiteId} 
              companyId={companyId} 
              viewAssetDetails={viewAssetDetails} 
              setViewAssetDetails={setViewAssetDetails} 
              displayPageIndex={displayPageIndex} 
              setDisplayPageIndex={setDisplayPageIndex} 
              navName={navName}
              setNavName={setNavName}
              setNavSiteViewName={setNavSiteViewName}
              setSiteAssetView={setSiteAssetView}
              setAssetDefaults={setAssetDefaults}
              mctClusterId={mctClusterId}
              mobileAppId={mobileAppId}
              forceReload={forceReload}
              setForceReload={setForceReload}
            />
          </div>
        :
          <div id="asset-details-container">
            <SiteAssetView
              setLoadingSiteViewData={setLoadingSiteViewData}
              timezone={timezone}
              localAssetId={localAssetId}
              assetDefaults={assetDefaults}
              setAssetPhoto={setAssetPhoto}
              setSiteAssetView={setSiteAssetView}
              setNavSiteViewName={setNavSiteViewName}
              navSiteViewName={navSiteViewName}
              setNavName={setNavName}
              scrollToTop={scrollToTop}
              editMode={editMode}
              setEditMode={setEditMode}
              setChangeDetected={setChangeDetected}
              changeDetected={changeDetected}
              editData={editData}
              setEditData={setEditData}
              initialFormData={initialFormData}
              setInitialFormData={setInitialFormData}
              setTooltipDescription={setTooltipDescription}
              setInvalid={setInvalid}
              siteViewData={siteViewData}
              forceReload={forceReload}
              setForceReload={setForceReload}
              setSiteViewData={setSiteViewData}
              setShowEditButton={setShowEditButton}
              setViewAssetDetails={setViewAssetDetails}
            />
          </div>
      }
    </Card>
  );
}

export default AssetsOverview;